import type { BusinessProcessVersion } from './types'

// Admin-only agent assumptions/limitations and manual follow-ups for a
// generated version. The parent renders this inside the Advanced disclosure.
export default function ProcessOutcome({ version }: { version: BusinessProcessVersion }) {
  return (
    <section className="grid gap-4 md:grid-cols-2">
      <div className="rounded-md border p-4">
        <h3 className="text-sm font-semibold">Suposições e limitações</h3>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-muted-foreground">
          {(version.assumptions_limitations.length ? version.assumptions_limitations : ['Nenhuma limitação declarada']).map((item) => <li key={item}>{item}</li>)}
        </ul>
      </div>
      <div className="rounded-md border p-4">
        <h3 className="text-sm font-semibold">Próximos passos manuais</h3>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-sm text-muted-foreground">
          {(version.manual_next_steps.length ? version.manual_next_steps : ['Nenhum passo manual declarado']).map((item) => <li key={item}>{item}</li>)}
        </ul>
      </div>
    </section>
  )
}
